import BoardThumbnail from "./BoardThumbnail.jsx";
export default BoardThumbnail;
